import { isDate, isDateOnly, isTimeOnly } from "./dateUtils";
import { DATE_FORMATS } from "../constants";

import dayjs, { Dayjs } from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const parseTimeOnlyString = (timeOnlyString: string): Dayjs => {
  const today = dayjs();
  const timeParsed = dayjs(timeOnlyString, DATE_FORMATS.HourMinuteSecond24Hour);
  return today
    .set('hour', timeParsed.hour())
    .set('minute', timeParsed.minute())
    .set('second', timeParsed.second());
}

const parseDateOnlyString = (dateOnlyString: string): Dayjs => dayjs(dateOnlyString, DATE_FORMATS.YearMonthDayIso).startOf('day');

export const cleanApiResponse = (response: any): any => {
  if (!response) {
    return response;
  }

  if (Array.isArray(response)) {
    for (let i = 0; i < response.length; i++) {
      response[i] = cleanApiResponse(response[i]);
    }
  } else if (typeof response === "object") {
    for (const key in response) {
      if (Array.isArray(response[key])) {
        for (let i = 0; i < response[key].length; i++) {
          response[key][i] = cleanApiResponse(response[key][i]);
        }
      } else if (typeof response[key] === "object") {
        response[key] = cleanApiResponse(response[key]);
      } else if (isDate(response[key])) {
        response[key] = dayjs(response[key]);
      } else if (isTimeOnly(response[key])) {
        response[key] = parseTimeOnlyString(response[key])
      } else if (isDateOnly(response[key])) {
        response[key] = parseDateOnlyString(response[key]);
      }
    }
  } else if (isDate(response)) {
    return dayjs(response);
  } else if (isTimeOnly(response)) {
    return parseTimeOnlyString(response);
  } else if (isDateOnly(response)) {
    return parseDateOnlyString(response);
  }

  return response;
};